import type { CheckboxField } from '@payloadcms/plugin-form-builder/types'
import type { FieldErrorsImpl, FieldValues, UseFormRegister } from 'react-hook-form'
import React from 'react'

import { Error } from './Error'

export const Checkbox: React.FC<
  CheckboxField & { errors: Partial<FieldErrorsImpl>; register: UseFormRegister<FieldValues> }
> = ({ name, defaultValue, errors, label, register, required }) => {
  return (
    <div className="field">
      <label htmlFor={name} className="flex-row items-center gap-2 normal-case tracking-normal">
        <input
          defaultChecked={defaultValue}
          id={name}
          type="checkbox"
          className="w-auto"
          {...register(name, { required })}
        />
        {label}
        {required && ' *'}
      </label>
      {errors[name] && <Error name={name} />}
    </div>
  )
}
